import { useQuery } from "@tanstack/react-query";
import type { VisitAddress } from "@/components/ui/box.schema";
import { api } from "@/lib/api/client";

export interface SectionReview {
  updated_at: string;
  counts: { enrollments: number; credit_enrollments: number; sessions: number; published_content: number };
  blockers: { id: string; sentence: string; address: VisitAddress }[];
  discard: { eligible: boolean; blockers: string[] };
  ranking: { state: "ready"; value: { candidates: { id: string; eligible: boolean; blocked: boolean; rank: number | null }[]; lead: string | null } };
}
export function useCourseRecordReview(id: string, enabled: boolean) {
  return useQuery({ queryKey: ["course-record-review", id], queryFn: () => api.get<SectionReview>(`/courses/${id}/record-review`), enabled, retry: false });
}
